import { bind } from 'decko'
import { LiveElement, LiveNodeList } from 'live-node-list'

const selectors = {
  form: '.collection-filter__form',
  group: '.collection-filter__filter',
  inputs: '.collection-filter__item input, .collection-filter__item textarea',
  submit: '.collection-filter__submit',
}

export default class FilterTwo {
  /**
   * @type {LiveElement}
   */
  container = new LiveElement('.collection')

  /**
   * @type {LiveNodeList}
   */
  inputs = new LiveNodeList(selectors.inputs)

  /**
   * @type {LiveNodeList}
   */
  filterTitles = new LiveNodeList('.collection-filter__title')

  /**
   * @type {LiveNodeList}
   */
  filterToggles = new LiveNodeList('#filter-toggle, #filter-close')

  /**
   * @type {LiveElement}
   */
  sortField = new LiveElement('#sort')

  /**
   * @type {LiveElement}
   */
  clearFiltersButtons = new LiveElement('#clear-filters')

  /**
   * @type {LiveElement}
   */
  horizontalFilter = new LiveElement('.collection-filter-style-horizontal')

  /**
   * @type {LiveNodeList<HTMLInputElement>}
   */
  priceRangeInputs = new LiveNodeList('[data-filter-price-input]')

  /**
   * @type {LiveNodeList<HTMLInputElement>}
   */
  priceRangeSliders = new LiveNodeList('[data-filter-price-slider]')

  /**
   * @type {LiveElement<HTMLButtonElement>}
   */
  priceRangeClear = new LiveElement('#clear-price-range')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.inputs.addEventListener('input', event => {
      const input = event.currentTarget || event.target
      const form = input.closest(selectors.form)

      if (form) {
        form.submit()
      }
    })

    this.filterTitles.addEventListener('click', event => {
      event.preventDefault()

      const target = event.currentTarget || event.target
      target.setAttribute(
        'aria-expanded',
        target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
      )
    })

    this.filterToggles.addEventListener('click', event => {
      const item = event.currentTarget || event.target
      const expanded = item.getAttribute('aria-expanded') === 'true'

      this.filterToggles.forEach(item => {
        item.setAttribute('aria-expanded', expanded ? 'false' : 'true')
      })

      const fn = expanded ? 'remove' : 'add'
      this.container.item.classList[fn]('collection--filter-open')
    })

    this.clearFiltersButtons.addEventListener('click', this.clearFilters)

    if (this.horizontalFilter.item) {
      const horizontalFilterTriggers = this.horizontalFilter.item.querySelectorAll('.collection-filter__filter')
      horizontalFilterTriggers.forEach(item => {
        item.addEventListener('click', event => {
          horizontalFilterTriggers.forEach(loopItem => {
            if (loopItem != item) {
              loopItem.setAttribute('aria-expanded', 'false')
            }
          })
          const expanded = item.getAttribute('aria-expanded') === 'true'
          item.setAttribute('aria-expanded', expanded ? 'false' : 'true')
        })
      })
    }

    this.sortField.addEventListener('change', event => {
      const url = new URL(window.location)
      url.searchParams.set('sort_by', event.currentTarget.value)
      window.location = url
    })

    this.priceRangeInputs.addEventListener('input', event => {
      clearTimeout(this.priceRangeChangeTimeout)
      event.stopPropagation()

      const input = event.currentTarget || event.target
      const type = input.dataset.filterPriceInput
      const slider = [...this.priceRangeSliders.items].find(
        slider => slider.dataset.filterPriceSlider === type,
      )

      if (slider) {
        slider.value = input.value
      }

      const wrapper = slider.closest('.collection-filter__price-range-slider')
      if (wrapper) {
        wrapper.style.setProperty(
          `--${type}-value`,
          `${(input.value / input.max) * 100}%`,
        )
      }

      this.priceRangeChangeTimeout = setTimeout(() => {
        this.submit()
      }, 250)
    })

    this.priceRangeSliders.addEventListener('input', event => {
      clearTimeout(this.priceRangeChangeTimeout)
      event.stopPropagation()

      const slider = event.currentTarget || event.target
      const type = slider.dataset.filterPriceSlider
      const input = [...this.priceRangeInputs.items].find(
        input => input.dataset.filterPriceInput === type,
      )

      if (input) {
        input.value = slider.value
      }

      const wrapper = slider.closest('.collection-filter__price-range-slider')
      if (wrapper) {
        wrapper.style.setProperty(
          `--${type}-value`,
          `${(input.value / input.max) * 100}%`,
        )
      }

      this.priceRangeChangeTimeout = setTimeout(() => {
        this.submit()
      }, 250)
    })

    this.priceRangeClear.addEventListener('click', event => {
      event.preventDefault()
      this.priceRangeInputs.items.forEach(input => (input.value = ''))
      this.submit()
    })
  }

  @bind
  submit() {
    this.form.item
      ?.querySelectorAll('input, textarea, select')
      .forEach(input => input.classList.add('pseudo-disabled'))
    this.form.item?.submit()
  }
}
